import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, BookOpen, ShieldCheck, RefreshCw } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative h-[100dvh] w-full flex flex-col items-center justify-center overflow-hidden bg-primary" data-id="element-67">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-accent-cyan/10 rounded-full blur-[80px] pointer-events-none" data-id="element-68"></div>

      <div className="relative z-10 flex flex-col items-center justify-between h-full w-full max-w-5xl mx-auto px-4 py-8 md:py-12" data-id="element-69">
        {/* 1. Branding */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="shrink-0" data-id="element-70">
          <span className="font-heading font-bold text-xl md:text-3xl tracking-tight" data-id="element-71">
            <span className="text-text-main" data-id="element-72">Guia</span>
            <span className="text-accent-cyan" data-id="element-73">Digital360</span>
            <span className="text-xs ml-1 text-text-muted align-top" data-id="element-74">™</span>
          </span>
        </motion.div>

        {/* 2. Promise */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex flex-col items-center text-center max-w-3xl" data-id="element-75">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-card border border-accent-cyan/30 text-accent-cyan text-[10px] font-bold tracking-wider mb-4" data-id="element-76">
            EDICIÓN 2026 - QUIMICA APLICADA
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-4" data-id="element-77">
            Tu planificación resuelta de 3° a 6° año.
          </h1>

          <p className="text-sm md:text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-78">
            Material específico para{' '}
            <strong className="text-text-main font-semibold" data-id="element-79">
              Electromecánica, Electrónica, Informática y Construcciones
            </strong>
            . 16 tomos diseñados por y para la escuela técnica.
          </p>
        </motion.div>

        {/* 3. Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="relative w-full max-w-[280px] md:max-w-[420px] flex-1 flex items-center justify-center min-h-0" data-id="element-80">
          <div className="absolute inset-0 bg-accent-cyan/20 blur-[40px] rounded-full" data-id="element-81"></div>
          <img src="https://cdn.magicpatterns.com/uploads/3chkFiLS6sUwcmLhoYorKu/quimica_aplicada_web_1200.webp" alt="Química Aplicada MegaPack 16 Tomos" className="relative z-10 w-full h-full object-contain drop-shadow-2xl" data-id="element-82" />
        </motion.div>

        {/* 4. CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="w-full flex flex-col items-center shrink-0 mt-4" data-id="element-83">
          <motion.button onClick={scrollToPricing} animate={{
          boxShadow: ['0 0 20px rgba(0, 200, 83, 0.3)', '0 0 40px rgba(0, 200, 83, 0.6)', '0 0 20px rgba(0, 200, 83, 0.3)'],
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-full sm:w-auto bg-accent-green hover:bg-[#00b34a] text-primary font-bold text-lg md:text-xl px-12 py-4 rounded-xl transition-all transform hover:scale-105 flex items-center justify-center gap-2 mb-4" data-id="element-84">
            QUIERO MI MEGAPACK AHORA
          </motion.button>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-[10px] md:text-[11px] text-text-muted font-medium uppercase tracking-wider max-w-3xl" data-id="element-85">
            <span className="flex items-center gap-1.5" data-id="element-86">
              <FileText className="w-3.5 h-3.5 text-accent-cyan" data-id="element-87" /> 100% PDF
            </span>
            <span className="hidden md:block w-1 h-1 bg-primary-card rounded-full" data-id="element-88"></span>
            <span className="flex items-center gap-1.5" data-id="element-89">
              <Zap className="w-3.5 h-3.5 text-accent-orange" data-id="element-90" /> Acceso
              inmediato
            </span>
            <span className="hidden md:block w-1 h-1 bg-primary-card rounded-full" data-id="element-91"></span>
            <span className="flex items-center gap-1.5" data-id="element-92">
              <BookOpen className="w-3.5 h-3.5 text-accent-cyan" data-id="element-93" /> Diseño INET
            </span>
            <span className="hidden md:block w-1 h-1 bg-primary-card rounded-full" data-id="element-94"></span>
            <span className="flex items-center gap-1.5" data-id="element-95">
              <ShieldCheck className="w-3.5 h-3.5 text-accent-green" data-id="element-96" /> Compra
              protegida por Mercado Pago
            </span>
            <span className="hidden md:block w-1 h-1 bg-primary-card rounded-full" data-id="element-97"></span>
            <span className="flex items-center gap-1.5" data-id="element-98">
              <RefreshCw className="w-3.5 h-3.5 text-accent-cyan" data-id="element-99" /> 7 días de
              reembolso
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}